import React, { createContext, useContext, useState } from 'react';

const ClientCtx = createContext(null);

export function ClientProvider({ children }) {
  const [activeClient, setActiveClient] = useState(null);
  return (
    <ClientCtx.Provider value={{ activeClient, setActiveClient }}>
      {children}
    </ClientCtx.Provider>
  );
}

export function useClientCtx() {
  return useContext(ClientCtx);
}
